import { render, staticRenderFns } from "./BlazeLanding.vue?vue&type=template&id=d6741380&scoped=true&"
import script from "./BlazeLanding.vue?vue&type=script&lang=js&"
export * from "./BlazeLanding.vue?vue&type=script&lang=js&"
import style0 from "./BlazeLanding.vue?vue&type=style&index=0&id=d6741380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6741380",
  null
  
)

export default component.exports